import { useEffect, useRef } from 'react';

// Yemək şəklini böyüdüb göstərən lightbox.
// Şəkil <canvas>-a çəkilir və mərkəzə "www.fiscalbusiness.net" su nişanı YAPIŞDIRILIR —
// beləcə həm ekran şəkli (screenshot), həm də sağ-klik "şəkli saxla" su nişanlı olur.
// Qeyd: brauzerdə tam screenshot qarşısını almaq mümkün deyil, amma su nişanı həmişə görünür.
const WATERMARK = 'Fiscal POS';

export default function ImageLightbox({ src, alt = '', onClose }) {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (!src) return undefined;
        let cancelled = false;
        const img = new Image();
        img.onload = () => {
            if (cancelled) return;
            const canvas = canvasRef.current;
            if (!canvas) return;
            const maxW = 1400;
            const scale = Math.min(1, maxW / (img.naturalWidth || maxW));
            const w = Math.max(1, Math.round((img.naturalWidth || 800) * scale));
            const h = Math.max(1, Math.round((img.naturalHeight || 800) * scale));
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext('2d');
            // Şəffaf PNG arxası QARA yox, AĞ olsun — əvvəlcə ağ dolğu, sonra şəkil
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, w, h);
            try { ctx.drawImage(img, 0, 0, w, h); } catch { /* taint olsa belə göstərmə davam edir */ }

            // Mərkəzdə böyük DÜZ su nişanı (ağ fonda da görünsün deyə tünd-boz)
            ctx.save();
            const fontPx = Math.max(20, Math.round(w * 0.075));
            ctx.font = `900 ${fontPx}px Arial, sans-serif`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = 'rgba(70,70,70,0.38)';
            ctx.fillText(WATERMARK, w / 2, h / 2);
            ctx.restore();

            // Künclərə kiçik təkrar su nişanı (kəsilməsi çətin olsun)
            ctx.save();
            ctx.globalAlpha = 0.32;
            ctx.fillStyle = '#555';
            const sf = Math.max(11, Math.round(w * 0.025));
            ctx.font = `bold ${sf}px Arial, sans-serif`;
            ctx.textBaseline = 'top';
            ctx.fillText(WATERMARK, 8, 8);
            ctx.textBaseline = 'bottom';
            ctx.textAlign = 'right';
            ctx.fillText(WATERMARK, w - 8, h - 8);
            ctx.restore();
        };
        img.src = src;
        return () => { cancelled = true; };
    }, [src]);

    if (!src) return null;
    const block = (e) => { e.preventDefault(); return false; };

    return (
        <div
            onClick={onClose}
            className="fixed inset-0 z-[200] flex items-center justify-center bg-black/90 p-3"
            style={{ backdropFilter: 'blur(2px)' }}
        >
            <button
                onClick={onClose}
                aria-label="Bağla"
                className="absolute right-3 top-3 flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-2xl leading-none text-white hover:bg-white/25"
            >
                ×
            </button>
            <canvas
                ref={canvasRef}
                aria-label={alt}
                onClick={(e) => e.stopPropagation()}
                onContextMenu={block}
                onDragStart={block}
                className="max-h-[88vh] max-w-[94vw] rounded-2xl object-contain shadow-2xl"
                style={{ WebkitUserSelect: 'none', userSelect: 'none', WebkitTouchCallout: 'none', touchAction: 'pinch-zoom' }}
            />
        </div>
    );
}
